export const prependPlus = (phoneNumber: string) =>
    phoneNumber.charAt(0) === '+' ? phoneNumber : `+${phoneNumber}`;
